 import React from "react";
// import CatalogueCategory from "./CatalogueCategory";
 
const CatalogueModals = ({
  showResetConfirmModal,
  setShowResetConfirmModal,
  resettingStock,
  handleResetStock,
  showCustomizationModal,
  setShowCustomizationModal,
  customizationSets,
  selectedCustomizations,
  setSelectedCustomizations,
  handleApplyCustomization,
}) => {
   return (
     <>

 {/* reset model */}

      {showResetConfirmModal && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 px-4">
          <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl overflow-hidden">
            <div className="px-6 py-5 border-b">
              <h2 className="text-lg font-semibold text-gray-900">
                Confirm Stock Reset
              </h2>
              <p className="mt-1 text-sm text-gray-500">
                This will reset stock for all catalogue items. This action
                cannot be undone.
              </p>
            </div>

            <div className="px-6 py-5">
              <div className="rounded-xl border border-red-100 bg-red-50 p-4">
                <p className="text-sm font-medium text-red-700">
                  Are you sure you want to reset stock?
                </p>
                <p className="mt-1 text-xs text-red-500">
                  Click confirm only if you really want to reset all stock
                  values.
                </p>
              </div>
            </div>

            <div className="flex justify-end gap-3 px-6 py-4 border-t bg-gray-50">
              <button
                type="button"
                onClick={() => setShowResetConfirmModal(false)}
                disabled={resettingStock}
                className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 text-sm hover:bg-gray-100 disabled:opacity-60"
              >
                Cancel
              </button>

              <button
                type="button"
                onClick={handleResetStock}
                disabled={resettingStock}
                className={`px-4 py-2 rounded-lg text-sm text-white ${
                  resettingStock
                    ? "bg-red-300 cursor-not-allowed"
                    : "bg-red-600 hover:bg-red-700"
                }`}
              >
                {resettingStock ? "Resetting..." : "Yes, Reset Stock"}
              </button>
            </div>
          </div>
        </div>
      )}

       {/* CUSTOMIZATION MODAL */}
        {showCustomizationModal && (
          <div className="fixed inset-0 bg-black/40 flex items-center montserrat-font-1 justify-center z-50">
            <div className="bg-white w-[700px] rounded-xl shadow-xl overflow-hidden">
              <div className="bg-emerald-500 text-white px-6 py-4 flex justify-between items-center">
                <h2 className="text-lg font-semibold">Customize Category</h2>
                <button
                  onClick={() => setShowCustomizationModal(false)}
                  className="text-white text-xl"
                >
                  ✕
                </button>
              </div>

              <div className="px-6 py-4 text-gray-600 text-sm montserrat-font-2">
                Select customization preferences to define how this category
                behaves in orders.
              </div>

              <div className="px-6 pb-4 grid grid-cols-2 gap-4 max-h-[400px] overflow-y-auto">
                {customizationSets.map((set) => {
                  const isSelected = selectedCustomizations.includes(
                    set.customize_field,
                  );

                  const toggleCustomization = () => {
                    setSelectedCustomizations((prev) =>
                      prev.includes(set.customize_field)
                        ? prev.filter((f) => f !== set.customize_field)
                        : [...prev, set.customize_field],
                    );
                  };

                  return (
                    <div
                      key={set.customize_field}
                      onClick={toggleCustomization}
                      className={`border rounded-xl p-4 shadow-sm cursor-pointer transition-all duration-200 ${
                        isSelected
                          ? "border-emerald-500 bg-emerald-50"
                          : "hover:border-gray-400"
                      }`}
                    >
                      <div className="flex items-center gap-2 mb-3 montserrat-font-1">
                        <input
                          type="checkbox"
                          checked={isSelected}
                          readOnly
                          className="accent-emerald-500 cursor-pointer"
                        />

                        <span className="font-medium text-gray-800">
                          {set.customize_field}
                        </span>
                      </div>

                      <div className="flex flex-wrap gap-2">
                        {set.options.map((opt, i) => (
                          <span
                            key={i}
                            className="bg-emerald-500 text-white px-3 py-1 rounded-full text-xs"
                          >
                            {opt}
                          </span>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="flex justify-between items-center px-6 py-4 border-t">
                <button
                  onClick={() => setShowCustomizationModal(false)}
                  className="px-5 py-2 border border-emerald-500 text-emerald-600 rounded-full hover:bg-emerald-50"
                >
                  Close
                </button>
                <button
                  onClick={handleApplyCustomization}
                  className="px-6 py-2 bg-emerald-500 text-white rounded-full hover:bg-emerald-600"
                >
                  Apply Customization
                </button>
              </div>
            </div>
          </div>
        )}
         </>
  );
};

export default CatalogueModals;